export type KissDatepickerViews = `${KissDatepickerViewEnums}`;
export enum KissDatepickerViewEnums {
  DAY = "day",
  MONTH = "month",
  YEAR = "year",
  TIME = "time"
}
